"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blOrderIdSchema = void 0;
const zod_1 = require("zod");
// `bl_order.id` is a stringified BigInt (see backend/prisma/seed.bl-level/
// orchestrator.ts: `owner_entity_id = bl.id.toString()`, and
// orders-bl-level-detail.service which serialises `id: row.id.toString()`
// for the FE). It is NOT a UUID. Schemas accepting a BL Order id as an
// `owner_entity_id` (Flow 2 upload, Flow 3 list, Flow 1 generate, …)
// should compose this constant rather than re-declaring the regex.
exports.blOrderIdSchema = zod_1.z
    .string()
    .regex(/^\d+$/u, 'owner_entity_id must be a numeric bl_order id');
//# sourceMappingURL=bl-order-id.js.map